import { Form, Input } from "antd";

const AlternateTaxIdentifierField = ({
  field,
  index,
  label,
  isDisabled = false,
  listName = "taxDomiciles",
  t = (value) => value,
}) => (
  <Form.Item shouldUpdate noStyle>
    {({ getFieldValue }) => {
      const tinUnavailable = getFieldValue([listName, index, "isTINIDAvailable"]);
      if (!tinUnavailable) return null;

      return (
        <Form.Item
          label={label}
          name={[field.name, "alternateTaxIdentifier"]}
          rules={[
            {
              required: true,
              message: t("Please enter alternate tax identifier"),
            },
          ]}
          className="md:col-span-2"
        >
          <Input placeholder={label} disabled={isDisabled} />
        </Form.Item>
      );
    }}
  </Form.Item>
);

export default AlternateTaxIdentifierField;
